import {TFunction} from 'react-i18next';
import {Section} from 'interfaces/Project';

export default function getSectionName(section: Section, index: number, t: TFunction): string {
  if (section.name) {
    return `${section.name} (${section.length}m)`;
  }
  return `${t('sectionIndex', {index})} (${section.length}m)`;
}
